import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { t } from 'i18next';
import { fetchAllNotifications, seenNotification } from 'src/services/notifications';
import { useTranslation } from "react-i18next";
import { jwtDecode } from "jwt-decode";
import { FaRegCalendarAlt } from 'react-icons/fa';

import "./notification.css";
import { getUserInfo } from 'src/services/userServicer';




// Dummy data for notifications
const dummyNotifications = [
  {
    id: 1,
    done: false,
    doneByUser: { name: 'John Doe' },
    doneAt: new Date(),
    type: 'Reminder',
    message: 'Meeting at 3 PM',
    functionsAll: 'Calendar',
    createdAt: new Date(),
  },
  {
    id: 2,
    done: true,
    doneByUser: { name: 'Jane Smith' },
    doneAt: new Date(),
    type: 'Alert',
    message: 'System update available',
    functionsAll: 'System',
    createdAt: new Date(),
  },
  {
    id: 3,
    done: false,
    doneByUser: { name: 'Admin' },
    doneAt: null,
    type: 'Message',
    message: 'New message received',
    functionsAll: 'Inbox',
    createdAt: new Date(),
  },
];

const Notification = () => {
  const { t } = useTranslation();

  const [allNotification, setAllNotification] = useState(dummyNotifications);
  const [loadingBox, setLoadingBox] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState<number>(0);

  const perPage = 10; // Items per page



  // Handle navigation
  const handleNavigation = (item: any) => {
    //console.log('Notification clicked:', item);
    // Add navigation logic here
  };

  // Filter notifications based on search term
  // const filteredNotifications = allNotification.filter((item) =>
  //   item.message.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   item.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   item.functionsAll.toLowerCase().includes(searchTerm.toLowerCase())
  // );
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const fetchNotificationsFromBackend = async () => {
    try {
      const data = await fetchAllNotifications(perPage, currentPage + 1, searchTerm)
      setAllNotification(data.data.notifications);
      setTotalPages(Math.ceil(data.data.totalCount / perPage)); 
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
    }
  };

  const seeNotifications = async () => {
    try {
        const user = await getUserInfo();
        if (!user?.id) return;
        let userId =  user.id || "";
      const response = await seenNotification(userId);
     // console.log(response);
    } catch (error) {
      console.error('Error seeing notifications:', error);  
    }
  };

  useEffect(() => {
    fetchNotificationsFromBackend();
    seeNotifications();
  }, [currentPage, searchTerm]);

  return (
    <div className="root">
     
      <h5 className="mb-4">{t('View All Notification')}</h5>
  
      <div className=" bg-white border-Card rounded p-4 mb-3" >
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
  {/* Search Input - في جهة اليسار */}
  <div style={{ flex: '1 1 250px' }}>
    <input
      type="text"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder={t('Search ...') || 'Search ...'}
      className="form-control  w-50 rounded"
    />
  </div>

  {/* باقي الحقول - في جهة اليمين */}
  <div className="d-flex align-items-center gap-3 flex-wrap justify-content-end">
  <div className="d-flex gap-3 flex-wrap">

  <div style={{ position: 'relative', width: '200px' }}>

  <FaRegCalendarAlt
    color="orange"
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      pointerEvents: "none",
      
    }}
  />
</div>


{/* To Date */}
<div style={{ width: '200px', position: 'relative' }}>

  <FaRegCalendarAlt
    color="orange"
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      pointerEvents: "none"
    }}
  />
</div>

</div>

    {/* Select Type */}
    <div style={{ width: '200px' }}>
      <select
        className="form-select form-select-sm rounded"
        defaultValue=""
        style={{height:"40px"}}
      >
        <option value="" disabled>Type</option>
        <option value="ticket">Ticket</option>
        <option value="issue">Issue</option>
        <option value="task">Task</option>
      </select>
    </div>
  </div>
</div>

        </div>

      <div className=" ">
     
        {allNotification.length > 0 ? (
            <div className="rounded-xl overflow-clip w-full">
              <div className=" overflow-x-auto h-full">
                <table className="styled-table">
                  <thead className="">
                    <tr className=" ">
                      <th className=" font-bold">{t('notification.About')}</th>
                      <th className=" font-bold">{t('notification.Message')}</th>
                      {/* <th className=" font-bold">{t('Function')}</th> */}
                      <th className=" font-bold">{t('notification.At')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allNotification.map((item, index) => (
                      <tr
                        key={index}
                        className="cursor-pointer "
                      >
                        <td className="" onClick={() => handleNavigation(item)}>
                          <p role="button" className="text-primary font-medium">
                            {item.type}
                          </p>
                        </td>
                        <td className="" onClick={() => handleNavigation(item)}>
                          {item.message}
                        </td>
                        {/* <td className="" onClick={() => handleNavigation(item)}>
                          {item.functionsAll}
                        </td> */}
                        <td className="" onClick={() => handleNavigation(item)}>
                          {format(new Date(item.createdAt), "yyyy-MM-dd 'at' hh:mm a")}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="text-center mt-8 bg-[#fab3b3] flex justify-center items-center p-2">
              No Data Available
            </div>
          )}

{allNotification.length > 0 && <div className="pagination-controls mt-3">
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() => setCurrentPage(0)}
                  disabled={currentPage === 0}
                >
                  {"<<"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                  disabled={currentPage === 0}
                >
                  {"<"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(
                        prev + 1,
                        totalPages - 1
                      )
                    )
                  }
                  disabled={
                    currentPage >= totalPages - 1
                  }
                >
                  {">"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() =>
                    setCurrentPage(
                      totalPages - 1
                    )
                  }
                  disabled={
                    currentPage >= totalPages - 1
                  }
                >
                  {">>"}
                </button>{" "}
                <span>
                  {t("page")}
                   {currentPage + 1} {t("To")} {totalPages}
                </span>
                </div>
              }
      </div>
    </div>
  );
};

export default Notification;